// ----------------------------------------------------------------------------
// Section: FAQs
// ----------------------------------------------------------------------------
//
// FAQs Section
// - Based on the Accordion pattern
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/accordion/accordion';

// Styles
import './_faqs.scss';

// -------------------------------------
// Variables
// -------------------------------------
var SECTION_SELECTOR = '.featured-ingredients';
var ACCORDION_BUTTON = '.js-accordion__button';
var INGREDIENT_IMAGE = '.js-ingredient__image';

// Constant trigger classes
var OPEN_CLASS = 'is-open';
document.querySelectorAll(SECTION_SELECTOR).forEach(section => {
  var buttons = section.querySelectorAll(ACCORDION_BUTTON);
  var images = section.querySelectorAll(INGREDIENT_IMAGE);
  var updateImages = index => {
    var button = buttons[index];
    var image = section.querySelector("".concat(INGREDIENT_IMAGE, ".ingredient__").concat(index + 1));

    // Remove all open classes
    images.forEach(img => img.classList.remove(OPEN_CLASS));

    // Add open only if button has is-open
    if (button.classList.contains(OPEN_CLASS) && image) {
      image.classList.add(OPEN_CLASS);
    }
  };
  buttons.forEach((button, i) => {
    var updateAfterToggle = () => {
      requestAnimationFrame(() => updateImages(i)); // Wait for class toggle to complete
    };
    button.addEventListener('click', updateAfterToggle);
    button.addEventListener('keydown', event => {
      var key = event.key;
      if (key === 'Enter' || key === ' ') {
        updateAfterToggle();
      }
    });
  });
});